import { render, staticRenderFns } from "./repeater.vue?vue&type=template&id=f2fb57ac&"
import script from "./repeater.vue?vue&type=script&lang=js&"
export * from "./repeater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports